export default "__VITE_ASSET__Dhk$Ub1i__"